const crypto = require('crypto')

export default function md5(input) {
  let md5sum = crypto.createHash('md5')
  md5sum.update(input)

  return md5sum.digest('base64')
}
